export enum CartItemType {
    plan,
    item
}



// WEBPACK FOOTER //
// /codebuild/output/src3048926480/src/src/app/shared/enums/CartItemType.ts